/* Review Hero JavaScript */
const reviewsHero = document.querySelector(".reviews-hero");

if (reviewsHero){
    const rating = reviewsHero.querySelector(".reviews-hero__inline-reviews__rating");
    const count = reviewsHero.querySelector(".reviews-hero__inline-reviews__count-inner");

    function updateSnippet(data) {
        let object = data;
        console.log(JSON.stringify(data));
        count.innerHTML = data.reviewAggregate.ratingAndReviewCount;
    }

    fetch('https://api.okendo.io/v1/stores/1bc21dbb-4834-41c1-8fe2-92e07717e7d1/review_aggregate')
      .then(response => response.json())
      .then(data => updateSnippet(data));

      fetch('https://api.okendo.io/v1/stores/1bc21dbb-4834-41c1-8fe2-92e07717e7d1/reviews')
      .then(response => response.json())
      .then(data => 
        console.log(JSON.stringify(data)));
}